import _ from 'lodash'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as moment from 'moment'
import store from '../store'
import VueCookie from 'vue-cookie'
/**
 * Import de tous les fichiers de traduction
 */
// import messages from './translate'
// import messages from './translations'

import traduction from './translations' // traduction targetfirst
var messages = traduction

// let messages = await import('./translations');
/**
 * Utilisation par VueJS du module de traduction et des cookies
 */
Vue.use(VueI18n)
Vue.use(VueCookie)

/**
 * Définition de la langue de l'application
 * recherche de la langue du navigateur
 * si cookie de langue alors prend sa valeur
 * si user en session qui a une langue alors se sera celle-ci
 * si pas connu, alors langue par défaut => 'en'
 */
let locale = Vue.cookie.get('wz-lang') || store.state._User.lang || navigator.language.split('-')[0] || navigator.userLanguage
const langs = ['fr', 'en', 'es']
if (_.indexOf(langs, locale) === -1) {
  locale = 'en'
}

/**
 * Définition de la langue par défaut du module de date
 */
moment.locale(locale)

/**
 * Création d'une instance VueI18n
 */
const i18n = new VueI18n({
  locale: locale, // langue par défaut
  fallback: 'en', // langue si pas de traduction pour la clé
  messages // injection des fichiers de traduction
})

export default i18n



// WEBPACK FOOTER //
// ./src/translation/index.js